// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__2UuwO","main":"login_main__9UUB0","content":"login_content__c71hu","footer":"login_footer__2nj0o"};